module.exports = __webpack_public_path__ + "a760241f14235f46ee2e394fe16aefd7.svg";